import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage'
import 'firebase/auth'
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyBgYSAYy9MQfKVlSN5xuxNkJIzouAmUJz8",
  authDomain: "petproject-qbelnc.firebaseapp.com",
  databaseURL: "https://petproject-qbelnc.firebaseio.com",
  projectId: "petproject-qbelnc",
  storageBucket: "petproject-qbelnc.appspot.com",
  messagingSenderId: "148188166508",
  appId: "1:148188166508:web:f90f08d602c56f75a41b49"
};
// Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const fs = firebase.firestore

export { fb, db, fs }
